// LogosSlider.js
import React from 'react';
import { motion } from 'framer-motion';
import siemensLogo from '../assets/logos/siemens_logo.png';
import phoenixLogo from '../assets/logos/phoenix_contact_logo.png';
import abbLogo from '../assets/logos/abb_logo.png';
import borunteLogo from '../assets/logos/borunte_logo.png';
import schneiderLogo from '../assets/logos/schneider_electric_logo.png';
import weidmuller from '../assets/logos/weidmuller_logo.png';
import delta from '../assets/logos/delta_logo.png';

const logos = [
  { src: siemensLogo, alt: 'Siemens' },
  { src: phoenixLogo, alt: 'Phoenix Contact' },
  { src: abbLogo, alt: 'ABB' },
  { src: borunteLogo, alt: 'Borunte' },
  { src: schneiderLogo, alt: 'Schneider Electric' },
  { src: weidmuller, alt: 'Weidmuller' },
  { src: delta, alt: 'Delta' },
];

const LogosSlider = () => {
  return (
    <section className="py-16 "
    style={{ backgroundColor: 'var(--background-color-typeB' }}>
      <div className="container mx-auto overflow-hidden">
        <motion.div
          className="flex items-center logos-container"
          initial={{ x: 0 }}
          animate={{ x: ['0%', '-117%'] }}
          transition={{ repeat: Infinity, repeatType: 'reverse', duration: 50, ease: 'linear' }}
        >
          {logos.concat(logos).map((logo, index) => (
            <div
              key={index}
              className="flex-shrink-0 w-1/5 md:w-1/6 px-4"
              style={{ minWidth: '150px' }}
            >
              <img
                src={logo.src}
                alt={logo.alt}
                className="h-20 w-full object-contain grayscale hover:grayscale-0 transition duration-300"
              />
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default LogosSlider;